import { userService } from "../services";
import config from "../config/config";

const LOCK_BASE = "http://192.168.60.242:8089";

const getBaseUrl = () =>
  JSON.parse(localStorage.getItem("config"))?.baseUrl ||
  LOCK_BASE;

const localData = JSON.parse(localStorage.getItem("data") || "{}");
const userId = localData?.id;
export const LocksAction = {
  getDashboardLockList,
  getLockList,
  addLock,
  linkVehicle,
  unlinkVehicle,
  getDashboardStatus,
  getTamperingStatus,
  getLockDropdown,
  getUsers,
  getAllAssignedLockToUser,
  assignLockToUser,
  unAssignLockToUser,
  getLockDetails,
  getLockDashboardAnalyticsData,
  getLockTripStatus,
  getLockTripCompleteionGraph,
  getLockDashboardTripAnalytics,
  getLockHistoryData,
  getLockAlertCount,
  getLockAlerts,
  getLockType,
  getLockPasscode,
  getFixedLockList,
  updateLock,
  getLockTrail,
  getLiveDeviceRoutesGeofences,
  updateLockMode,
  getStrictModeTrail,
  getLockUserDetails,
};

async function getDashboardLockList({
  isOperationalTrip,
  isHaltTrip,
  isOnTrip,
  batteryLevels,
  isAvailable,    // ← ADD
  isOnline,       // ← ADD
  isOffline,      // ← ADD
  search,
  lockType
} = {}) {
  const localData = JSON.parse(localStorage.getItem("data") || "{}");
  const userId = localData?.id;
  try {
    const params = new URLSearchParams({ userId });
    if (isOperationalTrip) params.append("isOperationalTrip", "true");
    if (isHaltTrip) params.append("isHaltTrip", "true");
    if (isOnTrip) params.append("isOnTrip", "true");
    if (isAvailable) params.append("isAvailable", "true");        // ← ADD
    if (isOnline) params.append("isOnline", "true");              // ← ADD
    if (isOffline) params.append("isOffline", "true");            // ← ADD
    if (search) params.append("search", search);                 
    if (lockType) params.append("lockType", lockType);
    if (Array.isArray(batteryLevels) && batteryLevels.length > 0) {
      params.append("batteryLevels", batteryLevels.join(","));
    }
    const apiEndpoint = `${getBaseUrl()}${config.apiName.LockDashboardAll}?${params.toString()}`;
    const response = await userService.get(apiEndpoint);
    if (response && response.data) return response.data;
    return null;
  } catch (error) {
    console.log("getLockTrackingData error", error);
    return null;
  }
}

async function getLockList({ pageNo = 0, pageSize = 10, keyword = "", isActive = null, batteryCategory = null, availabilityStatus = null }) {
  const localData = JSON.parse(localStorage.getItem("data") || "{}");
  const userId = localData?.id;
  try {
    const apiEndpoint = `${getBaseUrl()}${config.apiName.LockGetAll}?pageNo=${pageNo}&pageSize=${pageSize}`;
    const response = await userService.post(apiEndpoint, { pageNo, pageSize, keyword, isActive, userId, batteryCategory, availabilityStatus });
    if (response && response.data) return response.data;
    return null;
  } catch (error) {
    console.log("getLockList error", error);
    return null;
  }
}

async function addLock(payload) {
  try {
    const apiEndpoint = `${getBaseUrl()}${config.apiName.LockAdd}`;
    const response = await userService.post(apiEndpoint, payload);
    if (response && response.data) return response.data;
    return null;
  } catch (error) {
    console.log("addLock error", error);
    return null;
  }
}

async function linkVehicle(lockNumber, vehicleNumber) {
  try {
    const apiEndpoint = `${getBaseUrl()}${config.apiName.LockLinkVehicle}?lockNumber=${lockNumber}&vehicleNumber=${vehicleNumber}`;
    const response = await userService.post(apiEndpoint, {});
    if (response && response.data) return response.data;
    return null;
  } catch (error) {
    console.log("linkVehicle error", error);
    return null;
  }
}

async function unlinkVehicle(lockNumber) {
  try {
    const apiEndpoint = `${getBaseUrl()}${config.apiName.LockUnlink}/${lockNumber}`;
    const response = await userService.post(apiEndpoint, {});
    if (response && response.data) return response.data;
    return null;
  } catch (error) {
    console.log("unlinkVehicle error", error);
    return null;
  }
}

async function getDashboardStatus(noOfDays = 7) {
  try {
    const apiEndpoint = `${getBaseUrl()}${config.apiName.LockDashboardStatus}?noOfDays=${noOfDays}`;
    const response = await userService.get(apiEndpoint);
    if (response && response.data) return response.data;
    return null;
  } catch (error) {
    console.log("getDashboardStatus error", error);
    return null;
  }
}

async function getTamperingStatus(noOfDays = 1) {
  try {
    const apiEndpoint = `${getBaseUrl()}${config.apiName.LockTamperingStatus}?noOfDays=${noOfDays}`;
    const response = await userService.get(apiEndpoint);
    if (response && response.data) return response.data;
    return null;
  } catch (error) {
    console.log("getTamperingStatus error", error);
    return null;
  }
}

async function getLockDropdown() {
  try {
    const apiEndpoint = `${getBaseUrl()}${config.apiName.LockGetAll}?pageNo=0&pageSize=0`;
    const response = await userService.post(apiEndpoint, {
      pageNo: 0,
      pageSize: 0,
      keyword: "",
      isActive: null,
    });
    if (response && response.data && Array.isArray(response.data.data)) {
      return response.data.data.map((item) => ({
        id: item.id,
        serialNumber: item.serialNumber || "-",
        lockNumber: item.lockNumber || "-",
        lockStatus: item.isActive ? "Online" : "Offline",
        status: item.status || "IDLE",
        batteryPercentage: item.batteryStatus || 0,
        lat: item.lat || 0,
        lng: item.lang || 0,
      }));
    }
    return [];
  } catch (error) {
    console.log("getLockDropdown error", error);
    return [];
  }
}

async function getUsers(lockId) {
  try {
    const apiEndpoint = `${getBaseUrl()}${config.apiName.LockUsers}/${lockId}`;
    const response = await userService.get(apiEndpoint);
    if (response && response.data) return response.data;
    return null;
  } catch (error) {
    console.log("getLockList error", error);
    return null;
  }
}
async function getAllAssignedLockToUser(payload) {
  try {
    let apiEndpoint = `${JSON.parse(localStorage.getItem("config")).baseUrl}${config.apiName.LockGetAllByUser}/${payload.userid}`;
    let response = await userService.get(apiEndpoint);
    if (response) {
      return response.data;
    } else {
      return null;
    }
  } catch (error) {
    console.log("error", error);
    return null;
  }
}

async function assignLockToUser(payload) {
  try {
    const apiEndpoint = `${JSON.parse(localStorage.getItem("config")).baseUrl}${config.apiName.LockAssignToUser}`;
    const response = await userService.post(apiEndpoint, payload);

    if (response && (response.status === 200 || response.status === 201)) {
      return response.data;
    } else {
      if (response?.status === 400) {
        alert(response?.data?.message);
      }
      return null;
    }
  } catch (error) {
    console.error("Assign lock error:", error);
    return null;
  }
}
async function unAssignLockToUser(payload) {
  try {
    const apiEndpoint = `${JSON.parse(localStorage.getItem("config")).baseUrl}${config.apiName.LockUnAssign}`;
    const response = await userService.post(apiEndpoint, payload);

    if (response && (response.status === 200 || response.status === 201)) {
      return response.data;
    } else {
      if (response?.status === 400) {
        alert(response?.data?.message);
      }
      return null;
    }
  } catch (error) {
    console.error("UnAssign Lock error:", error);
    return null;
  }
}

async function getLockDetails(lockNumber) {
  const localData = JSON.parse(localStorage.getItem("data") || "{}");
  const userId = localData?.id;
  try {
    const apiEndpoint = `${getBaseUrl()}${config.apiName.LockDetail}?userId=${userId}&lockNumber=${lockNumber}`;
    const response = await userService.get(apiEndpoint);
    if (response && response.data) return response.data;
    return null;
  } catch (error) {
    console.log("getLockList error", error);
    return null;
  }
}
async function getLockDashboardAnalyticsData() {

  const localData = JSON.parse(localStorage.getItem("data") || "{}");
  const userId = localData?.id;
  try {
    const apiEndpoint = `${getBaseUrl()}${config.apiName.LockAnalyticsData}?userId=${userId}`;
    const response = await userService.get(apiEndpoint);
    if (response && response.data) return response.data;
    return null;

  } catch (error) {
    console.log("getLockDashboardAnalyticsData error", error);
    return null;
  }
}

async function getLockTripStatus(payload) {

  const localData = JSON.parse(localStorage.getItem("data") || "{}");
  const userId = localData?.id;
  try {
    const apiEndpoint = `${getBaseUrl()}${config.apiName.LockTripStatus}?userId=${userId}&type=${payload.type}`;
    const response = await userService.get(apiEndpoint);
    if (response && response.data) return response.data;
    return null;

  } catch (error) {
    console.log("getLockTripStatus error", error);
    return null;
  }
}
async function getLockTripCompleteionGraph(payload) {

  const localData = JSON.parse(localStorage.getItem("data") || "{}");
  const userId = localData?.id;
  try {
    const apiEndpoint = `${getBaseUrl()}${config.apiName.LockTripCompleteionGraph}?userId=${userId}&tripType=${payload?.tripType}`;
    const response = await userService.get(apiEndpoint);
    if (response && response.data) return response.data;
    return null;

  } catch (error) {
    console.log("getLockTripCompleteionGraph error", error);
    return null;
  }
}

async function getLockDashboardTripAnalytics(payload) {

  const localData = JSON.parse(localStorage.getItem("data") || "{}");
  const userId = localData?.id;
  try {
    const apiEndpoint = `${getBaseUrl()}${config.apiName.LockDashboardTripAnalytics}?userId=${userId}&type=${payload?.type}`;
    const response = await userService.get(apiEndpoint);
    if (response && response.data) return response.data;
    return null;

  } catch (error) {
    console.log("getLockDashboardTripAnalytics error", error);
    return null;
  }
}

async function getLockHistoryData(payload) {

  const localData = JSON.parse(localStorage.getItem("data") || "{}");
  const userId = localData?.id;
  try {
    const apiEndpoint = `${getBaseUrl()}${config.apiName.LockHistory}?lockNumber=${payload.lockNumber}&fromDate=${payload.fromDate}&toDate=${payload.toDate}`;
    const response = await userService.get(apiEndpoint);
    if (response && response.data) return response.data;
    return null;

  } catch (error) {
    console.log("getLockDashboardTripAnalytics error", error);
    return null;
  }
}

async function getLockAlertCount(noOfDays = 1) {
  const localData = JSON.parse(localStorage.getItem("data") || "{}");
  const userId = localData?.id;
  try {
    const apiEndpoint = `${getBaseUrl()}${config.apiName.LockAlertCount}?noOfDays=${noOfDays}&userId=${userId}`;
    const response = await userService.get(apiEndpoint);
    if (response && response.data) return response.data;
    return null;
  } catch (error) {
    console.log("getLockAlertCount error", error);
    return null;
  }
}

async function getLockAlerts(payload) {

  try {
    const configData = JSON.parse(localStorage.getItem("config"));
    const alertBaseUrl = JSON.parse(configData?.datas || "{}")?.alertBaseUrl ||
      configData?.baseUrl;

    const apiEndpoint = `${alertBaseUrl}${config.apiName.LockAlertsGetAll}`;
    const formattedPayload = {
      ...payload,
      fromDate: typeof payload.fromDate === "string"
        ? new Date(payload.fromDate).getTime()
        : payload.fromDate,
      toDate: typeof payload.toDate === "string"
        ? new Date(payload.toDate).getTime()
        : payload.toDate,
      alertTypeList: payload.alertTypeList || [],
      lockId: payload.lockId || null,
      lockNumber: payload.lockNumber || null,
      tripId: payload.tripId || null,
      pageNo: 0,
      pageSize: 0,
    };

    const response = await userService.post(apiEndpoint, formattedPayload);

    if (response && (response.status === 200 || response.status === 201)) {
      return response.data;
    } else {
      return null;
    }
  } catch (error) {
    console.log("getLockAlerts error", error);
    return null;
  }
}

async function getLockType() {
  try {
    const apiEndpoint = `${getBaseUrl()}${config.apiName.LockType}`;
    const response = await userService.get(apiEndpoint);
    if (response && response.data) return response.data;
    return null;
  } catch (error) {
    console.log("getLockType error", error);
    return null;
  }
}

async function getLockPasscode(lockNumber) {
  try {
    const apiEndpoint = `${getBaseUrl()}/api/get/passcode?lockNumber=${lockNumber}`;
    const response = await userService.get(apiEndpoint);
    if (response && response.data && response.data.responseCode===200) return response.data;
    else alert(response?.data?.message)
    return null;
  } catch (error) {
    console.log("getLockPasscode error", error);
    return null;
  }
}

async function getFixedLockList() {
  const localData = JSON.parse(localStorage.getItem("data") || "{}");
  const userId = localData?.id;
  try {
    const apiEndpoint = `${getBaseUrl()}${config.apiName.GetAllFixedLock}?userId=${userId}`;
    const response = await userService.get(apiEndpoint);
    if (response && response.data) return response.data;
    return null;
  } catch (error) {
    console.log("getFixedLockList error", error);
    return null;
  }
}

async function updateLock(payload) {
  try {
    const apiEndpoint = `${getBaseUrl()}${config.apiName.LockUpdate}`;
    const response = await userService.post(apiEndpoint, payload);
    if (response && response.data) return response.data;
    return null;
  } catch (error) {
    console.log("updateLock error", error);
    return null;
  }
}

async function getLockTrail({ lockNumber, pageNo = 0, pageSize = 10 }) {
  try {
    const apiEndpoint = `${getBaseUrl()}${config.apiName.LockTrail}?lockNumber=${lockNumber}`;
    const response = await userService.get(apiEndpoint);
    if (response && response.data) return response.data;
    return null;
  } catch (error) {
    console.log("getLockTrail error", error);
    return null;
  }
}

async function getLiveDeviceRoutesGeofences(payload) {
  try {
    const apiEndpoint = `${getBaseUrl()}${config.apiName.getLiveDeviceRoutesGeofences}`;
    const response = await userService.post(apiEndpoint, payload);
    if (response && response.data) return response.data;
    return null;
  } catch (error) {
    console.log("getLiveDeviceRoutesGeofences error", error);
    return null;
  }
}

async function updateLockMode(payload) {
  try {
    const apiEndpoint = `${getBaseUrl()}${config.apiName.UpdateLockMode}`;
    const response = await userService.post(apiEndpoint, payload);
    if (response && response.data) return response.data;
    return null;
  } catch (error) {
    console.log("updateLockMode error", error);
    return null;
  }
}

async function getStrictModeTrail(tripId) {
  try {
    const apiEndpoint = `${getBaseUrl()}${config.apiName.StrictModeTrail}?tripId=${tripId}`;
    const response = await userService.get(apiEndpoint);
    if (response && response.data) return response.data;
    return null;
  } catch (error) {
    console.log("getStrictModeTrail error", error);
    return null;
  }
}

async function getLockUserDetails(lockId) {
  try {
    const apiEndpoint = `${getBaseUrl()}${config.apiName.LockUserDetails}?lockId=${lockId}`;
    const response = await userService.get(apiEndpoint);
    if (response && response.data) return response.data;
    return null;
  } catch (error) {
    console.log("getLockUserDetails error", error);
    return null;
  }
}